$(document).ready(function () {
  $(document).on('click', '.event-cancel', function () {
    let event_id = $(this).data('event-id');
    let confirm_message = $(this).data('confirm-message');

    if (!confirm(confirm_message)) {
      return false;
    }

    $.ajax({
      type: 'POST',
      url: '/ajax/organizer_event/cancel',
      data: {
        event_id: event_id,
      },
    })
      .done(function (data) {
        if (data.message !== undefined && data.message !== null) {
          popupAlert();
          setTimeout(function () {
            document.location.href = '/organizer/events';
          }, 1500);
        }
      })
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      });

    return false;
  });
});
